import { ContentItem } from 'kentico-cloud-delivery';

export class Text extends ContentItem {

}